import { GDFHotPollyTypes, GDFRecordType } from '../../gdf/type';
import { WeatherPickingInfoLayer, WeatherPickingInfoObject } from '../../manager/types';
import { TooltipFromRaster } from './RasterTooltip';
import { TooltipFromFeature } from './RecordTooltip';
import { TooltipFromSubRecord } from './SubRecordTooltip';

export function hasTooltip(layer: WeatherPickingInfoLayer, object: WeatherPickingInfoObject): boolean {
    if (object.type === 'raster') {
        // All raster objects have tooltips except... those that don't...
        return !object.palette.noTooltip;
    }

    if (object.type === 'record') {
        if (object.record.type === GDFRecordType.hotpoly || object.record.type === GDFRecordType.hotpolyhi) {
            if (object.record.polyType === GDFHotPollyTypes.raim) {
                return false;
            }
        }

        return true;
    }

    if (object.type === 'subRecord') {
        return true;
    }

    throw new Error('Unknown object type');
}

export function WeatherTooltip(props: { layer: WeatherPickingInfoLayer; object: WeatherPickingInfoObject }) {
    if (props.object.type === 'record') {
        return <TooltipFromFeature productId={props.layer.product.id} palette={props.layer.palette} item={props.object.record} />;
    }

    if (props.object.type === 'raster') {
        return <TooltipFromRaster palette={props.object.palette} value={props.object.value} />;
    }

    if (props.object.type === 'subRecord') {
        return <TooltipFromSubRecord productId={props.layer.product.id} palette={props.layer.palette} item={props.object.record} />;
    }

    throw new Error('Unknown object type');
}
